export const Home = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 25V12L16 3L27 12V25C27 26.1046 26.1046 27 25 27H7C5.89543 27 5 26.1046 5 25Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M19 27L19 18C19 17.4477 18.5523 17 18 17L14 17C13.4477 17 13 17.4477 13 18L13 27" stroke="currentColor" stroke-width="2"/>
</svg>`;
